var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1218_5010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5548 17.0547H10.4253C9.62705 17.0547 8.97998 17.7018 8.97998 18.5C8.97998 19.2982 9.62705 19.9453 10.4253 19.9453H35.5548C36.353 19.9453 37.0001 19.2982 37.0001 18.5C37.0001 17.7018 36.353 17.0547 35.5548 17.0547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5548 6.21484H10.4253C9.62705 6.21484 8.97998 6.86191 8.97998 7.66016C8.97998 8.4584 9.62705 9.10547 10.4253 9.10547H35.5548C36.353 9.10547 37.0001 8.4584 37.0001 7.66016C37.0001 6.86191 36.353 6.21484 35.5548 6.21484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5548 27.8945H10.4253C9.62705 27.8945 8.97998 28.5416 8.97998 29.3398C8.97998 30.1381 9.62705 30.7852 10.4253 30.7852H35.5548C36.353 30.7852 37.0001 30.1381 37.0001 29.3398C37.0001 28.5416 36.353 27.8945 35.5548 27.8945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95117 9.61133C3.02877 9.61133 3.90234 8.73776 3.90234 7.66016C3.90234 6.58255 3.02877 5.70898 1.95117 5.70898C0.873569 5.70898 0 6.58255 0 7.66016C0 8.73776 0.873569 9.61133 1.95117 9.61133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95117 20.4512C3.02877 20.4512 3.90234 19.5776 3.90234 18.5C3.90234 17.4224 3.02877 16.5488 1.95117 16.5488C0.873569 16.5488 0 17.4224 0 18.5C0 19.5776 0.873569 20.4512 1.95117 20.4512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95117 31.291C3.02877 31.291 3.90234 30.4174 3.90234 29.3398C3.90234 28.2622 3.02877 27.3887 1.95117 27.3887C0.873569 27.3887 0 28.2622 0 29.3398C0 30.4174 0.873569 31.291 1.95117 31.291Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1218_5010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.d64fa2c175f0de76b8614cad8bcacde3.svg";
export { ForwardRef as ReactComponent };